
export default {
    namespaced: true,
    state: {
        percents: [],
        periodList: [],
        periodValue: null,
    },
    getters: {
        PERCENTS: state => {
            return state.percents;
        },
        PERIOD_LIST: state => {
            return state.periodList;
        },
        PERIOD_VALUE: state => {
            return state.periodValue;
        },
    },
    mutations: {
        PERCENTS: (state, payload) => {
            return state.percents = payload;
        },
        PERIOD_LIST: (state, payload) => {
            return state.periodList = payload;
        },
        PERIOD_VALUE: (state, payload) => {
            return state.periodValue = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/alert/config',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let data = responseData.data;
                    payload.th.percents = state.percents = data.percent
                    state.periodList = data.period.list
                    payload.th.periodValue = state.periodValue = data.period.value
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        SAVE: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/alert/config/save',
                parameter: {
                    percents: state.percents,
                    period: state.periodValue,
                },
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    console.log(responseData)
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                }
            });
        }
    }
}